export default __webpack_public_path__ + "static/media/Inconsolata-Medium.07bf27c8.ttf";